import { useQuery, UseQueryOptions } from 'react-query'
import { useConvertElectricityMeters } from './electricitymeter.converter'
import { path, reverse, sortBy } from 'ramda'

export const useElectricityMeters = (
  query?: any,
  options?: UseQueryOptions
) => {
  const { data, ...others } = useQuery(
    ['/device/electricitymeter/{pageNum}/{pageSize}', query],
    {
      cacheTime: 0,
      ...options,
    }
  )

  const dataSource = useConvertElectricityMeters(data)

  return {
    ...others,
    dataSource,
    loading: others.isLoading,
  }
}

//控制器型號
export const useElectricityControllerType = () => {
  const { data, refetch, isLoading, ...others } = useQuery(
    [`/device/electricitymeter/ctrler/types`],
    {
      select: (res: any) => path(['data'], res) as { ctrlerType: string }[],
    }
  )

  return {
    ...others,
    refetch,
    loading: isLoading,
    data,
  }
}

export const useElectricitySignalLog = (query?: {
  id: any
  start: number
  end: number
}) => {
  const { data, refetch, isLoading, ...others } = useQuery(
    [`/device/electricitymeter/{id}/signalLog`, query],
    {
      select: (res: any) => path(['data'], res) as any[],
      cacheTime: 0,
    }
  )

  return {
    ...others,
    refetch,
    loading: isLoading,
    data: reverse(data || []),
  }
}
